<div class="dailystatus">
    <div class="dailystatus__day">{{this.day}}</div>
    <div class="dailystatus__status dailystatus__status--{{this.status}}">
        @if (this.status === 'SEANCE') {
<i ngbTooltip="En séance" class="fa-solid fa-microphone"></i>
}
        @if (this.status === 'NO_SEANCE' || this.status === 'PUBLIC_HOLIDAY') {
<i ngbTooltip="Pas de séance prévue" class="fa-solid fa-ban"></i>
}
        @if (this.status === 'ABSENCE') {
<i ngbTooltip="Absence" class="fa-solid fa-umbrella-beach"></i>
}
        @if (this.status === 'MALADE') {
<i ngbTooltip="Maladie" class="fa-solid fa-kit-medical"></i>
}
        @if (this.status === 'STUDIO') {
<i ngbTooltip="Au studio" class="fa-solid fa-building-user"></i>
}
    </div>
</div>
